// extracted by mini-css-extract-plugin
module.exports = {"benefitWrapper":"BenefitItem_benefitWrapper__VBvD_","title":"BenefitItem_title___zyK2","description":"BenefitItem_description__0Ddw6"};